/** Minimal NEX PO row shape for folder resolution (mirrors API `nexFolderResolution.ts`). */
export type NexFolderResolutionPoRow = {
    id?: number;
    folder?: number;
    detailLines?: Array<{ poHeaderID?: number }>;
};

export function resolveNexFolderNoForPoHeader(
    poHeaderID: number,
    nexResponse: NexFolderResolutionPoRow[] | null | undefined,
): number | null {
    for (const po of nexResponse ?? []) {
        if (po.id === poHeaderID && typeof po.folder === 'number' && Number.isFinite(po.folder)) {
            return po.folder;
        }
        const lines = po.detailLines ?? [];
        if (lines.some((d) => d.poHeaderID === poHeaderID)) {
            return typeof po.folder === 'number' && Number.isFinite(po.folder) ? po.folder : null;
        }
    }
    return null;
}

export function resolveDefaultNexFolderNo(
    nexResponse: NexFolderResolutionPoRow[] | null | undefined,
    roNumberFallback: string,
): number | null {
    const folders: number[] = [];
    for (const po of nexResponse ?? []) {
        if (typeof po.folder === 'number' && Number.isFinite(po.folder)) {
            folders.push(po.folder);
        }
    }
    const unique = Array.from(new Set(folders));
    if (unique.length === 1) return unique[0];
    const parsed = parseInt(roNumberFallback, 10);
    return roNumberFallback.trim() && !Number.isNaN(parsed) ? parsed : null;
}

export function resolveNexFolderNoForApDistLine(
    poHeaderID: number | null,
    nexResponse: NexFolderResolutionPoRow[] | null | undefined,
    roNumberFallback: string,
): number | null {
    // 0 / null = no real PO header (manual unmatched orphan); use folder fallback.
    if (poHeaderID != null && poHeaderID > 0) {
        const fromPo = resolveNexFolderNoForPoHeader(poHeaderID, nexResponse);
        if (fromPo != null) return fromPo;
    }
    return resolveDefaultNexFolderNo(nexResponse, roNumberFallback);
}
